import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dataUser: {},
    empresaAberta: null,
    base_url: '',
    empresa: {
      horarios: [],
      entregas: [],
      agendamentos: [],
      destaques: [],
      gtags: []
    },
    zap: null,
    sacola: { produtos: [] },
    nolocal: { obs_pedido: '', onde_estou: '' },
    cardapio: {
      categorias: [],
      destaques: [],
      url: '/',
    },
    unidades: [],
    cidade: {},
    load: false,
    modalPush: 0,
    cartao_pagamento: null,
    url: '',
    beneficios: [],
    saldoFidelidade: null,
    pontosSacola: 0,
    id_theme: '1',
    taxa: null,
    pwaPrompt: null
  },

  mutations: {
    setDataUser: (state, data) => {
      localStorage.setItem('token', data.token);
      state.dataUser = data.dados;
      state.taxa = null;
    },

    setEmpresa: (state, data) => {
      state.empresa = data;
      state.base_url = data.server + data.token + '/';
      state.empresa.zonas = (data.zonas || []);
      const cartao = (data.pagamentos || []).find(pag => ['30', '32'].includes(pag.id_pagamento));
      state.cartao_pagamento = cartao ? cartao.id_pagamento : null;
    },

    logout(state) {
      localStorage.removeItem('token');
      sessionStorage.removeItem('cuponsReadonly');
      state.saldoFidelidade = null;
      state.sacola = { produtos: [], origin: '1' };
      state.dataUser = {};
    },

    setProdutosSacola(state, data) {
      let total = 0;
      let pontos = 0;

      if (data.token !== state.empresa.token) {
        let expiracao = state.nolocal.expiracao || (new Date().getTime() + ((1000 * 60 * 60) * 24));
        state.sacola = {
          token: state.empresa.token,
          empresa: state.empresa.nome_fantasia,
          dominio_delivery: state.empresa.dominio_delivery,
          origin: data.origin || null,
          nolocal: data.nolocal || null,
          produtos: data.produtos,
          cliente: {},
          id_pagamento: '',
          tipo_pedido: '',
          valor_frete: 0,
          id_cupom: '',
          total: 0,
          troco: 0,
          obs_pedido: '',
          expiracao
        }
      }

      state.sacola.produtos.forEach(p => {
        total += (p.quantidade * parseFloat(p.valor));
        pontos += (!isNaN(p.pontos) ? parseInt(p.pontos) : 0);
      });

      state.sacola.total = total;
      state.pontosSacola = pontos;
      localStorage.setItem('sacola', JSON.stringify(state.sacola));
    },

    clearSacola(state) {
      state.sacola.produtos = [];
      state.sacola.origin = '1';
    },

    setPrompt(state, data) {
      state.pwaPrompt = data;
    }
  },
  actions: {
  },
  modules: {
  }
})
